import src from "IMAGE";
export default { src, width: 483, height: 104, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AM/d/8vb/9Pg/93n/+Ts/8/e/9Hf/+Xt/wDK2v/O3f/P3v/L2//L2//L2//N3P/f6f806CsY1P865wAAAABJRU5ErkJggg=="};
